import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, account }) =>
    present(
      repository
        .getPlanzoneRole(account, planzone)
        .then((role) => ({ role, planzone, account }))
        .catch(() => Promise.reject({ planzone, account })),
    );
}

export type { Interactor };

export { createInteractor };
